export enum OrderSources
{
    APP = 1,
    KIOSK = 2,
    DELIVERY = 3,
    TILL = 4,
    DRIVE = 5,
    UNKNOWN = 6,
    WEB = 7
}